import axios from 'axios'
import { apiHost } from '../config/env.conf'

export default {
    
    /**
     * 获取首页数据
     * @param { int }    salePlatform  平台，0 全部 1 美团 2 点评
     * @param { string } startDate     开始日期
     * @param { string } endDate       结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    getIndexData (salePlatform, startDate, endDate, hasDailyData) {
        return axios.get(`/rimet/fe/mtp/biz/operation/data/supplier`, {
            params: {
                salePlatform: salePlatform,
                startDate: startDate,
                endDate: endDate,
                hasDailyData: hasDailyData
            }
        })
    },
    
    /**
     * 7天汇总数据
     * @param { int }    salePlatform  平台，0 全部 1 美团 2 点评
     * @param { string } date          日期
     * @param { int }    sortType      排序类型，1 增幅排序 2 跌幅排序
     * @param { string } sortKey       排序关键字
     * @param { int }    sortValueType 排序值类型，1 增长率 2 绝对值
     */
    getSevenData (salePlatform, date, sortType, sortKey, sortValueType) {
        return axios.get(`/rimet/fe/mtp/biz/operation/data/deal/week`, {
            params: {
                salePlatform: salePlatform,
                date: date,
                sortType: sortType,
                sortKey: sortKey,
                sortValueType: sortValueType
            }
        })
    },
    
    /**
     * 商品分析
     * @param { int }    salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string } startDate    开始日期
     * @param { string } endDate      结束日期
     * @param { int }    productStr   搜索商品名称、ID
     * @param { int }    pageNum      第几页
     * @param { int }    pageSize     每页多少条
     */
    getProductData (salePlatform, startDate, endDate, productStr, hasDailyData, pageNum, pageSize) {
        return axios.get(`/rimet/fe/mtp/biz/operation/data/deal`, {
            params: {
                salePlatform: salePlatform,
                startDate: startDate,
                endDate: endDate,
                searchStr: productStr,
                hasDailyData: hasDailyData,
                pageNum: pageNum || 1,
                pageSize: pageSize || 10
            }
        })
    },
    
    /**
     * 下载经营数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    downloadOperateData (salePlatform, startDate, endDate, hasDailyData) {
        window.open(`${apiHost}/rimet/fe/mtp/biz/operation/data/supplier/download?salePlatform=${salePlatform}&startDate=${startDate}&endDate=${endDate}&hasDailyData=${hasDailyData}`);
    },
    
    /**
     * 下载商品数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } searchStr    搜索内容
     */
    downloadProductData (salePlatform, startDate, endDate, searchStr, hasDailyData) {
        window.open(`${apiHost}/rimet/fe/mtp/biz/operation/data/deal/download?salePlatform=${salePlatform}&startDate=${startDate}&endDate=${endDate}&searchStr=${searchStr}&hasDailyData=${hasDailyData}`);
    },
    
    /**
     * 下载交易数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    downloadTransactionData (salePlatform, startDate, endDate, hasDailyData) {
        window.open(`${apiHost}/rimet/fe/mtp/biz/operation/data/order/download?salePlatform=${salePlatform}&startDate=${startDate}&endDate=${endDate}&hasDailyData=${hasDailyData}`);
    }
    
}



// WEBPACK FOOTER //
// ./src/api/menpiaoDataPlatform.js